import { Metamodel } from '../base/model';
import { IModel, IAttribute, IVersioningDataset, TabularTypeDataset } from 'shell-models-lib';
import { AzurePostgreSqlLinkedService } from 'app/model/linkedservice/azure-db-postgre.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azurePostgreSQL.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzurePostgreSql_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzurePostgreSql_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzurePostgreSqlLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzurePostgreSqlTableDataset extends TabularTypeDataset implements IVersioningDataset {
    public static readonly MODEL: IModel;
    public static readonly VERSION: IAttribute;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version: string = __IS_FABRIC_DPE__ ? '2.0' : undefined;

    public shouldHonorConnectionVersion(): boolean {
        return this.version === '2.0';
    }

}
